import { render, staticRenderFns } from "./SearchReceptions.vue?vue&type=template&id=969e625c&scoped=true"
import script from "./SearchReceptions.vue?vue&type=script&lang=js"
export * from "./SearchReceptions.vue?vue&type=script&lang=js"
import style0 from "./SearchReceptions.vue?vue&type=style&index=0&id=969e625c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969e625c",
  null
  
)

export default component.exports